import { SharedDefinitions } from "@mrdm-self-service-frontend/shared/data-access-definitions";
import { AvailableApplicationRole } from "../types";
import { getAppRoleKey } from "./application-role-key";

export function getRoleLevel(
    row: AvailableApplicationRole,
    availableRolesDictionary: Record<string, AvailableApplicationRole>
): number {
    if (row == null || row.parentApplicationRoleCode == null) return 0;

    const parent = getParentRole(row, availableRolesDictionary);

    return 1 + getRoleLevel(parent, availableRolesDictionary);
}

export function getSortName(
    row: AvailableApplicationRole,
    availableRolesDictionary: Record<string, AvailableApplicationRole>,
    definitions: SharedDefinitions
): string {
    if (row == null) return "";
    if (row.parentApplicationRoleCode == null)
        return getRoleName(row.applicationRoleCode, definitions);

    const parent = getParentRole(row, availableRolesDictionary);

    return (
        getSortName(parent, availableRolesDictionary, definitions) +
        "_" +
        getRoleName(row.applicationRoleCode, definitions)
    );
}

function getParentRole(
    role: AvailableApplicationRole,
    availableRolesDictionary: Record<string, AvailableApplicationRole>
): AvailableApplicationRole {
    const parentKey = getAppRoleKey({
        applicationRoleCode: role.parentApplicationRoleCode,
        applicationInstanceCode: role.applicationInstanceCode,
        productCode: role.productCode
    });
    return availableRolesDictionary[parentKey];
}

function getRoleName(applicationRoleCode: string, definitions: SharedDefinitions): string {
    return definitions.applicationRole[applicationRoleCode]?.name || "";
}
